export default __webpack_public_path__ + "static/Sparkpowder-1522d50df6b80b1dd4588e9b85633da2.png";